// Display units grouped by type, mapped to the DB base unit they store as.
// DB unit column accepts: ml, grams, syringes, plates, jars, bags, units
export const UNIT_GROUPS = [
  {
    label: "Count",
    units: [
      { display: "syringes", db: "syringes", toBase: 1 },
      { display: "plates",   db: "plates",   toBase: 1 },
      { display: "jars",     db: "jars",     toBase: 1 },
      { display: "bags",     db: "bags",     toBase: 1 },
      { display: "units",    db: "units",    toBase: 1 },
    ],
  },
  {
    label: "Liquid",
    units: [
      { display: "ml",      db: "ml", toBase: 1 },
      { display: "fl oz",   db: "ml", toBase: 29.5735 },
      { display: "gallons", db: "ml", toBase: 3785.41 },
    ],
  },
  {
    label: "Weight",
    units: [
      { display: "grams", db: "grams", toBase: 1 },
      { display: "oz",    db: "grams", toBase: 28.3495 },
      { display: "lbs",   db: "grams", toBase: 453.592 },
    ],
  },
];

export const ALL_UNITS = UNIT_GROUPS.flatMap((g) => g.units);

export function findUnit(display) {
  return ALL_UNITS.find((u) => u.display === display) ?? null;
}

// Convert a user-entered value in displayUnit to the DB base value.
export function toBaseValue(value, displayUnit) {
  const u = findUnit(displayUnit);
  if (!u) return value;
  return value * u.toBase;
}

// Convert a DB base value back to the display unit for rendering.
export function fromBaseValue(value, displayUnit) {
  const u = findUnit(displayUnit);
  if (!u || u.toBase === 1) return value;
  return value / u.toBase;
}

// Given a db unit string, return the matching display unit (identity for db-native units).
export function dbUnitToDisplay(dbUnit) {
  // For count/ml/grams the db unit IS the display unit.
  const direct = ALL_UNITS.find((u) => u.db === dbUnit && u.toBase === 1);
  return direct ? direct.display : dbUnit;
}

// Hint shown beneath the unit picker when a non-base unit is selected.
export function storageHint(displayUnit) {
  const u = findUnit(displayUnit);
  if (!u || u.toBase === 1) return null;
  return `stored as ${u.db}`;
}
